var React = require('react');

function SliderArrowLeftWhite (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M82 21H2","stroke":"white","strokeWidth":"1.4","key":0}),React.createElement("path",{"d":"M23.5 41L2 21L23.5 1","stroke":"white","strokeWidth":"1.4","key":1})]);
}

SliderArrowLeftWhite.defaultProps = {"width":"82","height":"42","viewBox":"0 0 82 42","fill":"none"};

module.exports = SliderArrowLeftWhite;

SliderArrowLeftWhite.default = SliderArrowLeftWhite;
